import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pp_token');
  const acct = localStorage.getItem('pp_active_account');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (acct) config.headers['X-Account-Id'] = acct;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('pp_token');
      if (!window.location.pathname.includes('/login') && window.location.pathname.startsWith('/plannerapp')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
